import { render, staticRenderFns } from "./addPrices.vue?vue&type=template&id=75e092c7&scoped=true"
import script from "./addPrices.vue?vue&type=script&lang=js"
export * from "./addPrices.vue?vue&type=script&lang=js"
import style0 from "./addPrices.vue?vue&type=style&index=0&id=75e092c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e092c7",
  null
  
)

export default component.exports